import {useAuth0} from '@auth0/auth0-react';
import React, {useEffect} from 'react';

import Auth0Loading from './Auth0Loading';

const Login = () => {
    const {loginWithRedirect} = useAuth0();

    useEffect(() => {
        loginWithRedirect();
    }, [loginWithRedirect]);

    return <Auth0Loading />;
};

export default Login;
